enum MileageSettingsMileageNumberCreationModel {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
  DICT = "DICT",
}

export default MileageSettingsMileageNumberCreationModel;
